import styled from "styled-components";

export const MetricsContainer = styled.div`
    margin-bottom: 24px;

    @media print {
        display: block;

        .highcharts-container {
            max-width: 1050px;
            position: static;

            & > svg {
                max-width: 1050px;
            }
        }
    }
`;
